import { useState } from 'react';
import ajax from '@client/components/ajax';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { maxFileSizeBytes } from '@client/new/common/videos/videos.constants';
import { FormMedia } from '../model/programForm.types';

export type UseMediaUploadResult = {
  isUploading: boolean;
  error: string | null;
  upload: (file: File) => Promise<void>;
  setError: (message: string | null) => void;
};

export const useMediaUpload = (
  onUploaded: (media: FormMedia) => void,
): UseMediaUploadResult => {
  const creatorId = useInfluencerId();
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const upload = async (file: File) => {
    if (file.size > maxFileSizeBytes) {
      setError('File too large. Max file size is 100MB.');
      return;
    }
    setError(null);
    setIsUploading(true);
    try {
      const isVideo = file.type.startsWith('video');
      const metadata = await ajax.upload(file, creatorId, {
        skipCompression: isVideo,
      });
      onUploaded(metadata);
    } catch (error) {
      console.error('Media upload failed', error);
      setError('Upload failed. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };

  return { isUploading, error, upload, setError };
};
